import ATableFullPage from 'views/components/Table/ATableFullPage'
import { ListRequestParams } from 'modules/domain/types'
import { Dispatch, FC, SetStateAction } from 'react'
import { endpoints } from 'modules/endpoints'
import { useColumns } from './useColumns'

type Props = {
  listRequestParams: ListRequestParams
  listParamsUpdated: Dispatch<SetStateAction<ListRequestParams>>
  isFiltersLoaded: boolean
}

export const CarriersWithoutDocsTable: FC<Props> = ({ listRequestParams, listParamsUpdated, isFiltersLoaded }) => {
  const refetch = () => listParamsUpdated((prev) => ({ ...prev }))

  const columns = useColumns(refetch)

  return (
    <ATableFullPage
      columns={columns}
      dataEndpoint={endpoints.LogisticsKR.missingDocs()}
      listParamsUpdated={listParamsUpdated}
      listRequestParams={listRequestParams}
      page={listRequestParams.page}
      isFiltersLoaded={isFiltersLoaded}
    />
  )
}
